export default __webpack_public_path__ + "static/img-nhs-app-d498b03607fcd95184a7e368898b6080.jpg";